<template class="template-account">
    <div class="account">
        <!-- <div class="nav-count">
            <ul style="width: 240px;text-align:left">
                <li :class="{'active':currentNav=='accountInfo'}" @click="jumpTo('accountInfo')">
                    <router-link to="/Account/AccountInfo">
                        <a-icon type="user" />
                        账号信息
                    </router-link>
                </li>
                <li :class="{'active':currentNav=='pathManage'}" @click="jumpTo('pathManage')">
                    <router-link to="/Account/PathManage">
                        <a-icon type="robot" />
                        机器人列表
                    </router-link>
                </li>
                <li :class="{'active':currentNav=='sourcePackage'}" @click="jumpTo('sourcePackage')">
                    <router-link to="/Account/SourcePackage">
                        <a-icon type="folder" />
                        资源包列表
                    </router-link>
                </li>
            </ul>
        </div> -->

        <div class="content">
            <router-view></router-view>
        </div>
        <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
            <a-icon style="z-index:1000;font-size:25px" type="message" />
        </router-link> -->
    </div>
</template>

<script>
export default {
    name: 'Account',
    props: {
        msg: String
    },
    data() {
        return {
            currentNav: '',
        };
    },
    methods: {
        jumpTo(type) {
            this.currentNav = type
        },
    },
    mounted: function () {
        this.currentNav = sessionStorage.getItem('leftNavItem')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .nav-count ul{
        height: 100%;
        background: #fff;
        li{
            height: 48px;
            line-height: 48px;
            text-align: left;
            padding-left: 24px;
            a{
                color: rgba(80, 80, 80, 1);
                display: block;
                width: 100%;
                height:48px;
                text-decoration: none;
            }
        }
        li.active{
            background: rgba(34, 215, 187, 0.1);
            color: rgba(34, 215, 187, 1);
            border-right: 2px solid rgba(34, 215, 187, 1);
            a{
                color: rgba(34, 215, 187, 1);
            }
        }
    }
    .template-account{
        height: 100%;
    }
    .account{
        display: flex;
        height: 100%;
        flex: 3;
        background: #eee;
    }
    .account div.content{
        flex-grow:1;
        // margin-left: 24px;
        // padding-top: 24px;
        // padding-right: 24px;
        // padding-bottom: 70px;
        height: 100%;
        overflow-y: auto;
    }
</style>
